import { render } from "./NavBack.vue?vue&type=template&id=98a6835e&scoped=true"
import script from "./NavBack.vue?vue&type=script&lang=js"
export * from "./NavBack.vue?vue&type=script&lang=js"

import "./NavBack.vue?vue&type=style&index=0&id=98a6835e&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a6835e"]])

export default __exports__